/*
  echarts组件封装
  id:元素id ，唯一
  chartStyle:容器样式
  colors:颜色
  legendData:图例
  seriesData:所需数据
  xData:X轴显示的数据
  yData:Y轴显示的数据
*/
export default {
  props: {
    // 此处id切记不可传重复
    id: {
      type: String,
      default: '',
    },
    // 样式
    chartStyle: {
      type: Object,
      default: () => { },
    },
    // 标题
    titleData: {
      type: Object,
      default: () => { },
    },
    // 副标题
    subtitleData: {
      type: Object,
      default: () => { },
    },
    // 网格
    gridData: {
      type: Object,
      default: () => { },
    },
    // 颜色
    colors: {
      type: Array,
      default: () => [],
    },
    // 提示框
    tooltipData: {
      type: Object,
      default: () => { },
    },
    // 图例
    legendData: {
      type: Array,
      default: () => [],
    },
    // series
    seriesData: {
      type: Array,
      default: () => [],
    },
    // x 轴
    xData: {
      type: Array,
      default: () => [],
    },
    // x 轴样式
    xStyle: {
      type: Object,
      default: () => { },
    },
    // y 轴
    yData: {
      type: Array,
      default: () => [],
    },
    // 缩放
    dataZoomData: {
      type: Array,
      default: () => [],
    },
    // 是否有点击事件
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartsDom: null,
      option: null,
      resizeTimer: null,
      tooltipConfig: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderColor: '#333',
        // borderRadius: 10,
        borderWidth: 0,
        shadow: false,
        textStyle: {
          color: '#FFFFFF',
          fontSize: 12,
        },
      },
    };
  },
  watch: {
    // 监听 series变化
    seriesData: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            if (this.chartsDom) {
              // 先销毁，释放内存
              this.chartsDom.dispose();
            }
            this.init();
          });
        }
      },
      deep: true, // 对象内部属性的监听，关键。
    },
  },
  mounted() {
    // 部分暂时隐藏的 chart图，在显示的时候监听不到 seriesData的变化，需由 mounted来调用
    this.$nextTick(() => {
      if (this.chartsDom) {
        // 先销毁，释放内存
        this.chartsDom.dispose();
      }
      this.init();
    });
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    // 解除监听
    window.removeEventListener('resize', this.resize);
    // 销毁 echart实例
    if (this.chartsDom) {
      this.chartsDom.dispose();
    }
  },
  methods: {
    // 尺寸变化自适应
    resize() {
      if (this.resizeTimer) { clearTimeout(this.resizeTimer); }
      this.resizeTimer = setTimeout(() => { this.chartsDom.resize(); }, 200);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/Chart.js